import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { c as s } from "./classnames-DLUjLwnh.js";
import { w as p } from "./deprecation-Hz1LRzMC.js";
import { T as c } from "./Typography-DjQwU5Xn.js";
const f = {
  info: "bg-primary/10 text-primary border-primary/20",
  success: "bg-success/10 text-success border-success/20",
  warning: "bg-warning/10 text-warning border-warning/20",
  error: "bg-destructive/10 text-destructive border-destructive/20"
}, y = ({
  variant: o,
  type: n,
  title: u,
  description: r,
  onClose: d,
  className: m,
  icon: v,
  icons: l
}) => {
  typeof n < "u" && p({ component: "Alert", prop: "type", replacement: "variant" });
  const a = o ?? n ?? "info", h = {
    info: /* @__PURE__ */ e("svg", { className: "h-5 w-5 text-current", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true", children: /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z", clipRule: "evenodd" }) }),
    success: /* @__PURE__ */ e("svg", { className: "h-5 w-5 text-current", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true", children: /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z", clipRule: "evenodd" }) }),
    warning: /* @__PURE__ */ e("svg", { className: "h-5 w-5 text-current", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true", children: /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z", clipRule: "evenodd" }) }),
    error: /* @__PURE__ */ e("svg", { className: "h-5 w-5 text-current", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true", children: /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z", clipRule: "evenodd" }) })
  }, t = v || (l == null ? void 0 : l[a]) || h[a];
  return /* @__PURE__ */ e("div", { className: s("rounded-[var(--ds-radius-md)] p-4 border", f[a], m), role: "alert", children: /* @__PURE__ */ i("div", { className: "flex", children: [
    t && /* @__PURE__ */ e("div", { className: "flex-shrink-0", children: t }),
    /* @__PURE__ */ i("div", { className: s("ms-3 flex-1 md:flex md:justify-between", !t && "ms-0"), children: [
      /* @__PURE__ */ i("div", { children: [
        /* @__PURE__ */ e(
          c,
          {
            variant: "small",
            className: s("block font-bold", a === "error" ? "text-destructive" : "text-current"),
            children: u
          }
        ),
        r && /* @__PURE__ */ e("div", { className: "mt-2 text-sm opacity-90", children: typeof r == "string" ? /* @__PURE__ */ e("p", { children: r }) : r })
      ] }),
      d && /* @__PURE__ */ e(
        "button",
        {
          type: "button",
          onClick: d,
          className: "ms-auto inline-flex ps-3",
          children: /* @__PURE__ */ e(c, { variant: "small", className: "underline opacity-80 hover:opacity-100", children: "Dismiss" })
        }
      )
    ] })
  ] }) });
};
export {
  y as A
};
